import { render } from "./system_log.vue?vue&type=template&id=a964e344&scoped=true&ts=true"
import script from "./system_log.vue?vue&type=script&lang=ts"
export * from "./system_log.vue?vue&type=script&lang=ts"

import "./system_log.vue?vue&type=style&index=0&id=a964e344&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a964e344"]])

export default __exports__